package com.loyola.acessoescola.ui.addnew

import acessoescola.composeapp.generated.resources.Res
import acessoescola.composeapp.generated.resources.arrow_right_alt_24px
import acessoescola.composeapp.generated.resources.example
import acessoescola.composeapp.generated.resources.facial
import acessoescola.composeapp.generated.resources.hint_screen_header
import acessoescola.composeapp.generated.resources.hint_screen_line_1
import acessoescola.composeapp.generated.resources.hint_screen_line_2
import acessoescola.composeapp.generated.resources.hint_screen_line_3
import acessoescola.composeapp.generated.resources.hint_screen_line_4
import acessoescola.composeapp.generated.resources.hint_screen_line_5
import acessoescola.composeapp.generated.resources.next
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Card
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.Icon
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.loyola.acessoescola.ui.theme.AcessoEscolaTheme
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import org.jetbrains.compose.resources.vectorResource

@Composable
fun HintScreen(
    navToAddNewScreen: () -> Unit,
    paddingValues: PaddingValues
) {
    val cardsInnerPadding = 8.dp
    Scaffold(
        floatingActionButton = {
            FloatingActionButton(
                onClick = { navToAddNewScreen() }
            ) {
                Icon(
                    imageVector = vectorResource(Res.drawable.arrow_right_alt_24px),
                    contentDescription = stringResource(Res.string.next)
                )
            }
        },
        modifier = Modifier.padding(paddingValues)
    ) { paddingValues ->
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            modifier = Modifier
                .padding(paddingValues)
                .padding(horizontal = 8.dp)
                .verticalScroll(rememberScrollState())
                .fillMaxWidth()
        ) {

            Text(text = stringResource(Res.string.hint_screen_header))

            Card(modifier = Modifier.padding(vertical = 4.dp)) {
                Text(
                    text = stringResource(Res.string.hint_screen_line_1),
                    modifier = Modifier.padding(cardsInnerPadding)
                )
            }

            Card(modifier = Modifier.padding(vertical = 4.dp)) {
                Text(
                    text = stringResource(Res.string.hint_screen_line_2),
                    modifier = Modifier.padding(cardsInnerPadding)
                )
            }
            Card(modifier = Modifier.padding(vertical = 4.dp)) {
                Text(
                    text = stringResource(Res.string.hint_screen_line_3),
                    modifier = Modifier.padding(cardsInnerPadding)
                )
            }
            Card(modifier = Modifier.padding(vertical = 4.dp)) {
                Text(
                    text = stringResource(Res.string.hint_screen_line_4),
                    modifier = Modifier.padding(cardsInnerPadding)
                )
            }

            Text(
                text = stringResource(Res.string.hint_screen_line_5),
                modifier = Modifier.padding(top = 36.dp)
            )
            Image(
                painter = painterResource(Res.drawable.facial),
                contentDescription = stringResource(Res.string.example),
                modifier = Modifier.size(256.dp)/*fillMaxWidth()*/
            )
        }
    }
}

@Preview
@Composable
private fun HintScreenPreview() {
    AcessoEscolaTheme {
        HintScreen({}, PaddingValues(18.dp))
    }
}